<template>
    <div class="offlineMessage" :class="{'success_bg': message_sent}">
        <div v-if="!message_sent" class="form-group">
            <div v-html="label"></div>
            <div v-html="desc"></div>
            <div class="form-control">
                <label>{{ $gettext('Nombre') + '*' }}</label>
                <input v-model="message.name"
                       @focusout="validateProp('name')"
                       :class="{'error':!props.name.valid}"
                       :type="props.name.type"
                       :maxlength="props.name.max_length"
                       :placeholder="$gettext('Nombre')"/>
            </div>
            <div class="form-control">
                <label>{{ $gettext('Teléfono') }}</label>
                <input v-model="message.phone"
                       @focusout="validateProp('phone')"
                       :class="{'error':!props.phone.valid}"
                       :type="props.phone.type"
                       :maxlength="props.phone.max_length"
                       @keyup="cleanPhone('phone', message.phone)"
                       :placeholder="$gettext('Teléfono')"/>
            </div>
            <div class="form-control">
                <label>{{ $gettext('Email') + '*' }}</label>
                <input v-model="message.email"
                       @focusout="validateProp('email')"
                       :class="{'error':!props.email.valid}"
                       :type="props.email.type"
                       :placeholder="$gettext('Email')"/>
            </div>
            <div class="form-control">
                <label>{{ $gettext('Asunto de tu consulta') + '*' }}</label>
                <input v-model="message.subject"
                       @focusout="validateProp('subject')"
                       :class="{'error':!props.subject.valid}"
                       :type="props.subject.type"
                       :maxlength="props.subject.max_length"
                       :placeholder="$gettext('Asunto de tu consulta')"/>
            </div>
            <div class="form-control">
                <label>{{ $gettext('Detalle consulta') + '*' }}</label>
                <textarea v-model="message.message"
                          @focusout="validateProp('message')"
                          :class="{'error':!props.message.valid}"
                          :placeholder="$gettext('Detalle consulta')"></textarea>
            </div>
            <div class="form-control d-flex">
                <input type="checkbox"
                       :class="{'error':privacy_error}"
                       :checked="privacy_checked"
                       @click="privacyCheck"/>
                <label class="checkbox-label"
                       v-html="$gettextInterpolate($gettext('He leido y acepto la <a href=\'%{ policy_url }\'>Política de Datos</a>'), {policy_url: this.policyUrl})"></label>
            </div>

            <div v-if="message_error" class="warning_bg warning_message">
                <i class="waiting-icon icon-message-info"></i>
                <div v-html="message_error">
                </div>
            </div>

            <div class="form-control">
                <button @click.prevent="sendMessage">
                    {{ $gettext('Enviar consulta') }}
                </button>
            </div>
        </div>
        <div v-else class="d-flex">
            <i class="waiting-icon icon-message-confirmation success-color"></i>
            <div v-html="$gettext('Su consulta ha sido enviada con éxito.<br> En breve recibirá contestación por parte de uno de nuestros agentes.')">
            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'

export default {
    name: "OfflineMessageForm",
    data: () => {
        return {
            privacy_checked: false,
            privacy_error: false,
            message_sent: false,
            message_error: null,
            message: {
                name: null,
                phone: null,
                email: null,
                subject: null,
                message: null
            },
            props: {
                name: {valid: true, required: true, type: 'text', max_length: 20},
                phone: {valid: true, required: true, type: 'phone', min_length: 6, max_length: 20},
                email: {valid: true, required: true, type: 'email'},
                subject: {valid: true, required: true, type: 'text', max_length: 30},
                message: {valid: true, required: true, type: 'text'}
            }
        };
    },
    computed: {
        ...mapGetters(['policyUrl']),
        ...mapActions(['sendOfflineMessage']),
    },
    props: ['label', 'desc'],
    mounted() {
        this.resetMessage();
    },
    methods: {
        sendMessage() {
            if (this.validateData()){
                this.$store.dispatch('sendOfflineMessage', {message : this.message, callback: (response)=>{
                    let data = response.data;
                    if(data.success){
                        this.messageSent();
                    }else{
                        if (data.show_message){
                            this.message_error = data.message;
                        }else{
                            this.message_error = this.$gettext('Ha ocurrido un error al intentar enviar su mensaje.');
                        }
                    }
                }});
            }
        },
        messageSent(){
            this.resetMessage();
            this.message_sent = true;
        },
        validateData() {
            var valid = true;
            Object.keys(this.props).forEach((prop) => {
                if (!this.validateProp(prop)){
                    valid = false;
                }
            })
            if (!this.privacy_checked){
               valid = false;
               this.privacy_error = true;
            }else{
                this.privacy_error = false;
            }
            return valid;
        },
        privacyCheck(){
            this.privacy_checked = !this.privacy_checked;
            this.privacy_error = false;
        },
        validateProp(prop) {
            var prop_val = this.message[prop] ? this.message[prop] : "";
            var prop_type = this.props[prop].type;
            var valid = true;

            if (this.props[prop].required && (!prop_val || prop_val.length == 0)) {
                valid = false;
            }
            if (valid) {
                switch (prop_type) {
                    case "text":
                        break;
                    case "email":
                        valid = this.validEmail(prop_val);
                        break;
                    case "phone":
                        prop_val = this.cleanPhone(prop, prop_val);
                        break;
                }
            }
            if (
                (this.props[prop].max_length && prop_val.length > this.props[prop].max_length)
                ||
                (prop_val.length > 0 && this.props[prop].min_length && prop_val.length < this.props[prop].min_length)) {
                valid = false;
            }
            this.props[prop].valid = valid;
            return valid;
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        cleanPhone(prop, value) {
            value = value ? value : '';
            let aux = value.match(/([0-9]|\+)/g);
            aux = aux ? aux : [];
            value = aux.join('').substring(0, this.props[prop].max_length);
            this.$set(this.message, prop, value);

            return value;
        },
        resetMessage() {
            Object.keys(this.props).forEach((prop) => {
                this.props[prop].valid = true;
                this.message[prop] = null;
                this.message_sent = false;
                this.message_error = false;
            })
        }
    }
}
</script>

<style scoped>

</style>
